import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';

import { CommonService } from "../../_services/common.service";
import { SettingService } from "../../_services/setting.service";
import { FlashMessagesService } from "angular2-flash-messages";

@Component({
  selector: 'app-order-queue',
  templateUrl: './order-queue.component.html',
  styleUrls: ['./order-queue.component.css']
})
export class OrderQueueComponent implements OnInit {
  orderQueueForm: FormGroup;
  public loading = false;
  public orderQueueList: any = {};
  public objectKeys = Object.keys;
  public selectedWareHouses: any = {};
  public wareHouseList: Array<any> = [];
  public selectedHour: string = '03';
  public selectedminute: string = '00';
  public orderAmountError = null;
  public ware_houses: Array<any> = ['IL',
    'TX',
    'GA',
    'KS',
    'NJ',
    'CA','NV'];
  public hoursList: Array<any> = [];
  public minuteList: Array<any> = [];
  constructor(private CommonService: CommonService,
    private formBuilder: FormBuilder,
    private settingService: SettingService,
    private _flashMessagesService: FlashMessagesService

  ) {


  }

  ngOnInit() {
    // const controls = this.ware_houses.map(c => new FormControl(false));
    this.orderQueueForm = this.formBuilder.group({
      ware_houses: this.buildSkills(),
      min_queue_amount: [null, Validators.required]
    });
    this.setHourMinutes();
    this.getOrderQueueList();
  }

  buildSkills() {
    const arr = this.ware_houses.map(wh => {
      let whSelected = false;

      if (this.wareHouseList.indexOf(wh) == -1) {
        whSelected = false;
      } else {
        whSelected = true;
      }
      return this.formBuilder.control(whSelected);
    });
    return this.formBuilder.array(arr);
  }

  saveWareHouseData = function () {
    this.orderAmountError = null;
    if (this.orderQueueForm.value.min_queue_amount == "") {
      this.orderAmountError = "please enter order queue amount";
      return
    }
    if (this.orderQueueForm.value.min_queue_amount == 0) {
      this.orderAmountError = "Order queue amount must be greater than 0";
      return
    }
    const selectedWareHousesIds = this.orderQueueForm.value.ware_houses
      .map((v, i) => v ? this.ware_houses[i] : null)
      .filter(v => v !== null);
    let orderQueueOptions = {
      'order_min_amount': this.orderQueueForm.value.min_queue_amount,
      'warehouses': selectedWareHousesIds,
      'cron_time': this.selectedHour + ':' + this.selectedminute
    };
    this.settingService.setSetting(orderQueueOptions).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 3000
          });
        }
      },
      err => {
        console.log("Error =", err);

      }
    );
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  getOrderQueueList = function () {
    this.loading = true;
    this.CommonService.apiService(
      "GET",
      "queue/products/" + localStorage.getItem("userID")
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {            
            let cronTime = response.data.cron_time.split(":");
            this.selectedHour = cronTime[0];
            this.selectedminute = cronTime[1];
            this.orderQueueList = response.data.products;
            // this.orderQueueForm.get("min_queue_amount").setValue(response.data.order_min_amount);
            this.wareHouseList = response.data.warehouses;
            // this.orderQueueForm.get("ware_houses").setValue(this.buildSkills());
            this.orderQueueForm = this.formBuilder.group({
              ware_houses: this.buildSkills(),
              min_queue_amount: response.data.order_min_amount
            });
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  checkSelectedValue(arrvalue) {
    if (this.wareHouseList.indexOf(arrvalue) == -1) {
      return false
    } else {
      return true
    }
  }

  setHourMinutes() {
    let s: number;
    let m: number;
    for (s = 0; s < 24; s++) {
      this.hoursList.push(
        {
          hKey: s < 10 ? '0' + s : s,
          hValue: s < 10 ? '0' + s : s
        }
      )
    }

    for (m = 0; m < 60; m++) {
      this.minuteList.push(
        {
          mKey: m < 10 ? '0' + m : m,
          mValue: m < 10 ? '0' + m : m
        }
      )
    }

  }

  saveOrderGarment = function () {
    this._flashMessagesService.show("Order submitted sucessfully,status will updated by mail", {
      cssClass: "alert-success",
      timeout: 3000
    });
    this.CommonService.apiService(
      "GET",
      "queue/order/products/" + localStorage.getItem("userID")
    ).subscribe(
      (response: any) => {

        // if (response.status === true) {

        // }
      },
      err => {

        console.log(err);
      }
    );
  }



  onPrint() {
    window.print();
  }



}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/order-queue/order-queue.component.ts